module.exports = __webpack_public_path__ + "static/media/ev-tc.3169e772.svg";